import BackofficeRolesList from './views/BackofficeRoleList'
import BackofficeRoleEdit from './views/BackofficeRoleEdit'
import BackofficeRoleCreate from './views/BackofficeRoleCreate'

export default {
  name:"roles",
  list:BackofficeRolesList,
  edit:BackofficeRoleEdit,
  create:BackofficeRoleCreate,
}